// extracted by mini-css-extract-plugin
module.exports = {"rootArea":"TopicEditingPage_rootArea__2R3eK","managingArea":"TopicEditingPage_managingArea__7JGDG","separatedSection":"TopicEditingPage_separatedSection__ewnZt"};